import withErrorBoundary from '../../../core/components/errors/withErrorBoundary';
import useCategory from '../../../core/queries/useCategory';
import { memo } from '../../../core/types';
import TyreSearch from './TireSearch';
import { allTireFilters } from '.';

export const useTireSearchEnabled = () => {
    const { categoryAncestryIds, categoryLoading, categoryData } =
        useCategory();

    return {
        enabled:
            APP_ENV.TIRE_SEARCH_CATEGORY_ID &&
            categoryAncestryIds.includes(APP_ENV.TIRE_SEARCH_CATEGORY_ID) &&
            allTireFilters.some(field =>
                categoryData?.filters?.find(filter => filter.field === field)
            ),
        loading: categoryLoading,
    };
};

export const useTireSideFiltersEnabled = () => {
    const { categoryData, categoryLoading } = useCategory();

    return {
        enabled:
            categoryData?.filters?.find(
                filter => filter.field === 'PIM_ATT_TIRE_TYPE'
            ) !== undefined,
        loading: categoryLoading,
    };
};

const ProductListTyreSearch = () => {
    const { enabled } = useTireSearchEnabled();
    if (enabled) {
        return <TyreSearch />;
    }
    return null;
};

export default memo(withErrorBoundary(memo(ProductListTyreSearch)));
